



export default {
  /** Returns date string in format YYYY-MM-DD */
  dateToString (date) {
    if (!date || !date.constructor || !date.constructor.name || date.constructor.name != 'Date'
                                                             || !date.getTime())
      return '-'
    else
      return          date.getFullYear() + '-'
            + ('0' + (date.getMonth()+1)).slice(-2) + '-'
            + ('0' + (date.getDate())).slice(-2) 
  }
}